{
  "EMOJI": {
    "PLACEHOLDER": "Search emojis",
    "NOT_FOUND": "No emoji match your search",
    "REMOVE": "Remove"
  },
  "EMOJI_ICON_PICKER": {
    "TABS": {
      "ICONS": "Icons",
      "EMOJIS": "Emojis"
    },
    "SEARCH_EMOJI": "Search emoji…",
    "SEARCH_ICON": "Search icons…",
    "FREQUENTLY_USED": "Frequently used",
    "NO_EMOJI": "No emoji match your search",
    "NO_ICON": "No icons match your search",
    "REMOVE": "Eemalda",
    "STYLE": {
      "OUTLINE": "Outline icons",
      "FILLED": "Filled icons"
    },
    "COLORS": {
      "SLATE": "Slate",
      "RED": "Red",
      "ORANGE": "Orange",
      "AMBER": "Amber",
      "GREEN": "Green",
      "TEAL": "Teal",
      "BLUE": "Blue",
      "INDIGO": "Indigo",
      "VIOLET": "Violet",
      "PINK": "Pink"
    }
  }
}
